import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { ReactComponent as ArrowSvg } from "../../../../assets/rewamp/filters/dropdown-arrow.svg";

// filterDropDown-recipe.md glyph (10×6). Accepts MUI's icon-slot props (className for rotation).
export default function DropdownArrowIcon({ className, open, ...rest }) {
  return (
    <Box
      component={ArrowSvg}
      className={className}
      aria-hidden="true"
      width={10}
      height={6}
      sx={{ flexShrink: 0, transition: "transform 150ms", transform: open ? "rotate(180deg)" : "none" }}
      {...rest}
    />
  );
}

DropdownArrowIcon.propTypes = {
  className: PropTypes.string,
  open: PropTypes.bool,
};

DropdownArrowIcon.defaultProps = {
  className: undefined,
  open: false,
};
